import BaseModel from "../base/BaseModel.model";

export default class IndicatorType extends BaseModel {

    public name: string | null = null;
    public indicatorNumber:number | null = null;
    public indicatorGroupId: number | null;

  
    
    constructor(){
        super();
        this.init();
    }

    init(){
        this.name = null;
        this.indicatorNumber= null;
        this.indicatorGroupId = null;
    }
}